import * as React from 'react';
import { Div, List, ListItem, P } from '@kizi/core-components';

import { CbLogo } from '../CbLogo';
import { ScoreEntity } from '@kizi/comparator-core';

export interface TestoordelProps {
  scoreInput?: ScoreEntity;
}

const ScoresContainer: React.FC = ({ children }) => (
  <Div bg="second.2" borderRadius={2} px={3} maxWidth="330px">
    <List variant="accordionProductMobile">{children}</List>
  </Div>
);

export const Testoordel: React.FC<TestoordelProps> = ({ scoreInput }) => {
  if (!scoreInput?.scores.length) {
    return (
      <ScoresContainer>
        <ListItem>
          <CbLogo display="flex" mb={3} mx="auto" />
          <Div>
            We hebben op dit moment niet voldoende panelleden om een testoordeel
            te geven over deze provider.
          </Div>
        </ListItem>
      </ScoresContainer>
    );
  }

  const { scores: allScores } = scoreInput;

  // testoordel is always first in a list
  const [testoordelScore, ...scores] = allScores;
  const { year, quarter } = scoreInput;

  return (
    <ScoresContainer>
      <ListItem>
        <CbLogo display="flex" mb={3} mx="auto" />
        <P mt={3} mb={3}>
          <strong>Testoordeel: {testoordelScore.rating}</strong>
        </P>
        <Div>
          Deze score is gebaseerd op de ervaringen van het Consumentenbond
          Panel.
        </Div>
        <Div>
          Providermonitor kwartaal {quarter} {year}
        </Div>
      </ListItem>
      {scores.map(({ name, rating }, index) => (
        <ListItem
          key={`${index}-${name}`}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Div>{name}</Div>
          <Div>{rating}</Div>
        </ListItem>
      ))}
    </ScoresContainer>
  );
};
